import Box2D from 'box2dweb'
import { EventsManager } from './EventsManager'
import { CHARACTER_EVENTS } from './Events'

const b2Vec2 = Box2D.Common.Math.b2Vec2
const b2RayCastOutput = Box2D.Collision.b2RayCastOutput

const fixtureIsCharacter = fix => fix.GetBody().GetUserData().isPlayer || fix.GetBody().GetUserData().isEnemy
const isDirectHit = (fixA, fixB) => {
  let rayCastOutput = new b2RayCastOutput
  const bodyA = fixA.GetBody()
  const rayLength = 1
  const p1 = bodyA.GetPosition()
  const bodyAPosX = Math.cos(bodyA.GetAngle() / 180 * Math.PI)
  const bodyAPosY = Math.sin(bodyA.GetAngle() / 180 * Math.PI)
  const dest = new b2Vec2(
    rayLength * bodyAPosX,
    rayLength * bodyAPosY
  )
  const p2 = new b2Vec2(p1.x, p1.y)
  p2.Add(dest)
  
  const rayInput = {
    p1,
    p2,
    maxFraction: 1,
  }

  return fixB.RayCast(rayCastOutput, rayInput)
}
const isOvercharged = fix => fix.GetBody().GetUserData().coil || fix.GetBody().GetUserData().freezer

const applyExtraImpulse = (fixA, fixB) => {
  const bodyA = fixA.GetBody()
  const bodyB = fixB.GetBody()
  // direction based on angle
  const bodyAPosX = Math.cos(bodyA.GetAngle() / 180 * Math.PI)
  const bodyAPosY = Math.sin(bodyA.GetAngle() / 180 * Math.PI)

  // if both are normal, multiply hit by 5.
  let extraPower = 5
  // if hit-giver is Hulk, multiply hit power by 10.
  extraPower = bodyA.GetUserData().hulk ? 10 : extraPower
  // if hit-receiver is Hulk, keep hit power.
  extraPower = bodyB.GetUserData().hulk ? 0 : extraPower
  // if hit-giver is dead (freezed), keep hit power
  extraPower = !bodyA.GetUserData().impulse ? 0 : extraPower
  // x times of 
  const impulseVector = new b2Vec2(
    extraPower * bodyAPosX,
    extraPower * bodyAPosY
  )
  
  bodyB.ApplyImpulse(impulseVector, bodyB.GetWorldCenter())
}

const applyOverchargeCoil = (fixA, fixB) => {
  const bodyA = fixA.GetBody()
  const bodyB = fixB.GetBody()
  const posA = bodyA.GetPosition()
  const posB = bodyB.GetPosition().Copy()

  // distance between two objs position
  posB.Subtract(posA)
  // normalize to 0,0
  posB.Normalize()
  // x times of force of the kickback
  const extraPower = 15

  const impulseVector = new b2Vec2(
    extraPower * posB.x,
    extraPower * posB.y
  )

  bodyB.ApplyImpulse(impulseVector, bodyB.GetWorldCenter())
}

const overchargeReaction = (fixA, fixB) => {
  const bodyA = fixA.GetBody()
  const bodyB = fixB.GetBody()
  if (bodyA.GetUserData().coil) {
    bodyA.SetUserData({ ...bodyA.GetUserData(), coil: false})
    EventsManager.dispatch(CHARACTER_EVENTS.GETS_COIL, bodyB.GetUserData().uuid)
    EventsManager.dispatch(CHARACTER_EVENTS.DISCHARGE, bodyA.GetUserData().uuid)
    applyOverchargeCoil(fixA, fixB)
  }
  if (bodyB.GetUserData().coil) {
    bodyB.SetUserData({ ...bodyB.GetUserData(), coil: false})
    EventsManager.dispatch(CHARACTER_EVENTS.GETS_COIL, bodyA.GetUserData().uuid)
    EventsManager.dispatch(CHARACTER_EVENTS.DISCHARGE, bodyB.GetUserData().uuid)
    applyOverchargeCoil(fixB, fixA)
  }

  if (bodyB.GetUserData().freezer) {
    bodyB.SetUserData({ ...bodyB.GetUserData(), freezer: false})
    EventsManager.dispatch(CHARACTER_EVENTS.DISCHARGE, bodyB.GetUserData().uuid)
    EventsManager.dispatch(CHARACTER_EVENTS.GETS_FREEZER, bodyA.GetUserData().uuid)
    setTimeout(() => {
      EventsManager.dispatch(CHARACTER_EVENTS.UNFREEZE, bodyA.GetUserData().uuid)
    }, 5000);
    bodyA.SetUserData({ ...bodyA.GetUserData(), rotate: false, freeze: true, impulse: false })
  }
  if (bodyA.GetUserData().freezer) {
    bodyA.SetUserData({ ...bodyA.GetUserData(), freezer: false})
    EventsManager.dispatch(CHARACTER_EVENTS.DISCHARGE, bodyA.GetUserData().uuid)
    EventsManager.dispatch(CHARACTER_EVENTS.GETS_FREEZER, bodyB.GetUserData().uuid)
    setTimeout(() => {
      EventsManager.dispatch(CHARACTER_EVENTS.UNFREEZE, bodyB.GetUserData().uuid)
    }, 5000);
    bodyB.SetUserData({ ...bodyB.GetUserData(), rotate: false, freeze: true, impulse: false })
  }
}

const setHitBy = (fixA, fixB, directHitAtoB, directHitBtoA) => {
  const bodyA = fixA.GetBody()
  const bodyB = fixB.GetBody()
  const bodyAData = bodyA.GetUserData()
  const bodyBData = bodyB.GetUserData()
  const time = new Date()
  bodyA.SetUserData({ ...bodyAData, hitBy: bodyBData.uuid, hitByTime: time, hitByDirect: directHitBtoA })
  bodyB.SetUserData({ ...bodyBData, hitBy: bodyAData.uuid, hitByTime: time, hitByDirect: directHitAtoB })
}

export default function HitPhysics (b2Contact) {
  const fixA = b2Contact.GetFixtureA()
  const fixB = b2Contact.GetFixtureB()
  const isTwoCharactersHit = fixtureIsCharacter(fixA) && fixtureIsCharacter(fixB)
  if (isTwoCharactersHit) {
    const isDirectHitAtoB = isDirectHit(fixA, fixB)
    const isDirectHitBtoA = isDirectHit(fixB, fixA)
    setHitBy(fixA, fixB, isDirectHitAtoB, isDirectHitBtoA)
    if (isOvercharged(fixA) || isOvercharged(fixB)) {
      overchargeReaction(fixA, fixB)
    } else {
      // only if no ship is overcharged
      if (isDirectHitAtoB) {
        applyExtraImpulse(fixA, fixB)
      }
      if (isDirectHitBtoA) {
        applyExtraImpulse(fixB, fixA)
      }
    }
  }
}